import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { HANDOUTS, PAGE_BANNERS } from "../data/content";
import { FileText, Download } from "lucide-react";

export default function Handouts() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.resources} alt="Handouts" fallbackKey="resources" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Handouts</h1>
          <p>Free reference handouts. Click to download.</p>
          <ul className="!list-none !pl-0 space-y-3">
            {HANDOUTS.map((h) => (
              <li key={h.file} className="!mb-0">
                <a
                  href={`https://web.archive.org/web/2024/https://www.nourishnaturalhealth.org/wp-content/uploads/2015/04/${h.file}`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 border border-[#d6dcb6] bg-[#f6f8ec] p-3 hover:bg-[#e9eed3] transition-colors"
                >
                  <FileText className="w-5 h-5 text-[#7d8e54] flex-shrink-0" />
                  <span className="flex-1 nn-link">{h.label}</span>
                  <Download className="w-4 h-4 text-[#7d8e54]" />
                </a>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </div>
  );
}
